/* eslint-disable jsx-a11y/click-events-have-key-events */
import Box from '@material-ui/core/Box'
import Card from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardContent from '@material-ui/core/CardContent'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import React, { useCallback, useContext, useState } from 'react'

import { ModalNotAuth } from '../../../../Components'
import colorContext from '../../../../Context/colorContext'
import theme from '../../../../services/theme-service'
import { ChannelAttendanteI } from '../..'

interface Props {
  listChannel: ChannelAttendanteI[]
}

type ShortChannel = Pick<ChannelAttendanteI, 'titulo' | 'url'>

export default function ChannelAttendante({ listChannel }: Props): JSX.Element {
  const [isAuth, setIsAuth] = useState<boolean>(true)
  const { colors } = useContext(colorContext)
  const useStyles = makeStyles(() => ({
    main: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: colors.colorBackground,
      alignItems: 'center',
      padding: '40px 5px',
    },
    card: {
      borderRadius: 10,
      textTransform: 'capitalize',
      height: 184,
      width: '100%',
      color: colors.accentColor,
      fontSize: theme.typography.pxToRem(24),
      background: colors.colorGradient,
      '&:hover': {
        backgroundColor: colors.colorBackground,
      },
    },
    cardMobile: {
      marginBottom: 10,
      marginLeft: 5,
      marginRight: 5,
      width: '47%',
      height: 204,
      color: colors.accentColor,
      fontSize: theme.typography.pxToRem(18),
      backgroundColor: colors.textBody,
      boxShadow:
        '0px 6px 14px -6px rgba(24, 39, 75, 0.12), 0px 10px 32px -4px rgba(24, 39, 75, 0.05)',
      borderRadius: 4,
      '&:hover': {
        color: colors.textBody,
        background: `linear-gradient(180deg, ${colors.accentColor} 0%, ${colors.accentColor} 100%)`,
        transition: 'all 0.2s ease',
      },
    },
    textTitle: {
      position: 'relative',
      textTransform: 'uppercase',
      fontFamily: 'Roboto',
      padding: '10px 0px 0px 3px',
      marginBottom: 5,
      fontWeight: 700,
      color: colors.textBody,
      left: 8,
      fontSize: theme.typography.pxToRem(36),
      '&::after': {
        content: '""',
        display: 'block',
        width: 4,
        height: 30,
        backgroundColor: colors.accentColor,
        position: 'absolute',
        bottom: 11,
        marginLeft: -14,
        left: 5,
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: theme.typography.pxToRem(28),
        width: '85%',
        marginBottom: 19,
        '&::after': {
          bottom: 4,
        },
      },
    },
    textSubTitle: {
      position: 'relative',
      fontFamily: 'Roboto',
      paddingBottom: 40,
      color: colors.subTitleColor,
      letterSpacing: '0.1px',
      lineHeight: '24px',
      fontWeight: 400,
      fontSize: theme.typography.pxToRem(18),
    },
    icon: {
      width: 24,
      height: 24,
    },
    carrousel: {
      '& .slick-list': {
        margin: 0,
      },
    },
    boxChannels: {
      display: 'flex',
      justifyContent: 'center',
      gap: '13px 16px',
      [theme.breakpoints.down('md')]: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
      },
      [theme.breakpoints.down('xs')]: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
      },
    },
    box: {
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.down('sm')]: {
        alignItems: 'center',
      },
      [theme.breakpoints.down('xs')]: {
        textAlign: 'center',
      },
    },
  }))
  const classes = useStyles()

  const menuNameAtendimento =
    process.env.REACT_APP_NAME_ATENDIMENTO ?? 'OUTROS CANAIS DE ATENDIMENTO'
  const menuDescriptionAtendimento =
    process.env.REACT_APP_DESCRIPTION_ATENDIMENTO ??
    'Registre aqui sua manifestação'

  const handleNavigationToLink = useCallback((channelData: ShortChannel) => {
    window.open(channelData.url, '_blank', 'noopener noreferrer')
  }, [])

  return (
    <Box className={classes.main}>
      <ModalNotAuth open={!isAuth} onClose={(): void => setIsAuth(true)} />
      <Box display="flex" maxWidth="1320px" width="100%" flexDirection="column">
        <Box className={classes.box}>
          <Typography className={classes.textTitle} variant="h5" component="h2">
            {menuNameAtendimento}
          </Typography>
          <Typography className={classes.textSubTitle}>
            {menuDescriptionAtendimento}
          </Typography>
        </Box>
        <Box className={classes.boxChannels}>
          {listChannel.map((channel) => (
            <Card
              key={`${channel.titulo}-key`}
              className={classes.card}
              onClick={() => handleNavigationToLink(channel)}
            >
              <CardActionArea
                style={{
                  height: '100%',
                  color: colors.textAccentColor,
                }}
              >
                <CardContent
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <img
                    width="46px"
                    height="41px"
                    src={`${process.env.PUBLIC_URL}/assets/icons/${channel.icone}.svg`}
                    alt=""
                    aria-hidden="true"
                    loading="lazy"
                  />
                  <Typography
                    align="center"
                    variant="h5"
                    component="h3"
                    style={{
                      fontSize: theme.typography.pxToRem(24),
                      marginTop: 20,
                    }}
                  >
                    {channel.titulo}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          ))}
        </Box>
      </Box>
    </Box>
  )
}
